<template>
  <v-container fluid>
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article" class="mb-6">
      <v-card class="elevation-1 mb-6 rounded-lg">
        <v-card-title class="pa-7">
          Nabídka
          <v-spacer></v-spacer>
          <OfferStatus :max="false" :status="offer.status" />
        </v-card-title>
        <v-card-text class="pa-7">
          <v-row v-if="bannerBase64" class="">
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="2" class="py-0">
                  <div class="request-label">Banner</div>
                  <div class="request-value mt-2">
                    <v-img :src="bannerUrlBase64" />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">ID</div>
                  <div class="request-value mt-2">
                    {{ offer.id }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Název</div>
                  <div class="request-value mt-2">
                    {{ offer.name ? offer.name : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Typ</div>
                  <div class="request-value mt-2">
                    {{ offer.type ? offer.type.text : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col v-if="offer.condition" cols="6" class="py-0">
                  <div class="request-label">Podmínka</div>
                  <div class="request-value mt-2">
                    {{ offer.condition ? offer.condition.text : '-' }}
                  </div>
                </v-col>
                <v-col v-else cols="6" class="py-0">
                  <div class="request-label">Zákazníci</div>
                  <div class="request-value mt-2">
                    {{ offer.customersCount ? offer.customersCount : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="offer.condition">
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="6" class="py-0">
                  <div class="request-label">Typ objednávky</div>
                  <div class="request-value mt-2">
                    <v-row no-gutters>
                      <v-col
                        v-for="(type, index) in offer.condition.orderTypes"
                        :key="index"
                        cols="auto"
                      >
                        <span v-if="index === offer.condition.orderTypes.length - 1">
                          {{ type.text }}
                        </span>
                        <span v-else style="padding-right: 4px"> {{ type.text }}, </span>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="offer.orderStatusFrom.name === offer.orderStatusTo.name">
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Stav objednávky</div>
                  <div class="request-value mt-2">
                    {{ offer.orderStatusFrom ? offer.orderStatusFrom.text : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Stav objednávky od (včetně)</div>
                  <div class="request-value mt-2">
                    {{ offer.orderStatusFrom ? offer.orderStatusFrom.text : '-' }}
                  </div>
                </v-col>
                <v-col cols="4" class="py-0">
                  <div class="request-label">Stav objednávky do (včetně)</div>
                  <div class="request-value mt-2">
                    {{ offer.orderStatusTo ? offer.orderStatusTo.text : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Platnost od</div>
                  <div class="request-value mt-2">
                    {{ offer.validSince ? $dayjs(offer.validSince).format('D.M.YYYY') : '-' }}
                  </div>
                </v-col>
                <v-col cols="4" class="py-0">
                  <div class="request-label">Platnost do</div>
                  <div class="request-value mt-2">
                    {{ offer.validUntil ? $dayjs(offer.validUntil).format('D.M.YYYY') : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Zákazník - zobrazení</div>
                  <div class="request-value mt-2">
                    <EnabledDisabled v-if="offer" :value="offer.clientEnabled" />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="offer.attachments && offer.attachments.length">
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="12" class="py-0">
                  <div class="request-label">Přílohy</div>
                  <div
                    v-for="(item, index) in offer.attachments"
                    :key="index"
                    class="request-value mt-2"
                  >
                    <span>
                      <v-icon>mdi-attachment</v-icon>
                      <router-link to="" @click.native="downloadAttachment($event, item.uuid)">
                        {{ item.name }}
                      </router-link>
                    </span>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pl-7 pr-7 pb-7">
          <v-spacer></v-spacer>
          <template>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :to="{ name: 'personalized-offer.edit', params: { offerId: offer.id } }"
            >
              Editovat
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-skeleton-loader>
    <OfferCustomers v-if="offer && offer.customersCount > 0" :id="$route.params.offerId" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import EnabledDisabled from '../../../components/EnabledDisabled'
import OfferCustomers from '../../../components/offer/OfferCustomers'
import OfferStatus from '../../../components/offer/OfferStatus'
import arrayBufferToBase64 from '../../../utils/resource'
import { downloadFile } from '@/components/mixins/downloadFile'

export default {
  name: 'OfferDetail',
  components: { OfferStatus, OfferCustomers, EnabledDisabled },
  mixins: [downloadFile],
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      offer: {},
      bannerBase64: null,
      loading: false,
      saving: false,
    }
  },
  computed: {
    bannerUrlBase64() {
      if (this.bannerBase64) {
        return `data:image/png;base64,${this.bannerBase64}`
      }
      return null
    },
  },
  created() {
    this.loadOffer()
  },
  methods: {
    ...mapActions({
      getOffer: 'offer/getOffer',
      getArrayBuffer: 'upload/getArrayBuffer',
    }),
    loadOffer() {
      this.loading = true
      this.getOffer(this.$route.params.offerId)
        .then((response) => {
          this.offer = response.data
          this.loadOfferBanner(this.offer.banner.uuid)
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadOfferBanner(uuid) {
      this.loading = true
      this.getArrayBuffer(uuid)
        .then((response) => {
          this.bannerBase64 = arrayBufferToBase64(response.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    downloadAttachment(event, uuid) {
      this.downloadFile(event, `upload/${uuid}`)
    },
    back() {
      this.$router.push({
        name: 'personalized-offer',
      })
    },
  },
}
</script>
